<div class="row banner task-amend">
  <div class="col">
    <h6 class="pt-5px">
      <strong>Configure immigration document visa mappings </strong>
    </h6>
  </div>
  <div class="col">
    <button (click)="createActivity()" class="btn btn-secondary float-end">
      Create new document mapping
    </button>
  </div>
</div>

<form [formGroup]="activityFilter" class="search">
  <div class="d-flex justify-content-start">
    <div class="m-0 me-3 w-35">
      <ng-select
        [items]="countries"
        [closeOnSelect]="true"
        [multiple]="false"
        bindLabel="displayText"
        bindValue="id"
        formControlName="country"
        [placeholder]="'Country'"
        (change)="onCountryChange($event)"
      >
      </ng-select>
    </div>
    <div class="m-0 me-3 w-35">
      <ng-select
        [items]="visaTypesInfo"
        [closeOnSelect]="true"
        [multiple]="false"
        bindLabel="displayText"
        formControlName="visaType"
        [placeholder]="'Visa type value'"
        bindValue="id"
      >
      </ng-select>
    </div>

    <div class="m-0 me-3 w-35">
      <div class="d-flex justify-content-start check">
        <input type="checkbox" formControlName="isApprover" />
        <div class="txt">Approver</div>
      </div>
    </div>
    <div class="m-0 me-3 w-35">
      <div class="d-flex justify-content-start check">
        <input type="checkbox" formControlName="isRequestor" />
        <div class="txt">Requestor</div>
      </div>
    </div>

    <div class="m-0 me-3 w-35 d-flex flex-row">
      <button
        (click)="clearForm()"
        style="height: 29px"
        eosDebounce
        class="btn btn-primary ms-2"
      >
        Clear
      </button>

      <button
        (click)="onSubmit()"
        style="height: 29px"
        eosDebounce
        [disabled]="!activityFilter.valid"
        class="btn btn-primary ms-2"
        type="submit"
      >
        Search
      </button>
    </div>
  </div>
</form>

<div class="d-flex table-resp candid-table mt-3" *ngIf="activities.length">
  <table class="table table-bordered table-hover">
    <thead>
      <tr>
        <th [hidden]="true" scope="col">#</th>
        <th scope="col">Visa Type Value</th>
        <th scope="col">Document Type</th>
        <th scope="col">Document Value</th>
        <th scope="col">Document Name</th>
        <th scope="col" class="text-center">Approver / Requestor</th>
        <!-- <th scope="col" class="text-end">Order</th> -->
        <th scope="col" class="text-center">Action</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let act of activities; index as i">
        <td [hidden]="true">{{ i + 1 }}</td>
        <td>
          {{ act.visaTypeValue }}
        </td>
        <td>
          {{ act.documentType }}
        </td>
        <td>
          {{ act.documentValue }}
        </td>
        <td>
          {{ act.documentName }}
        </td>
        <td class="text-center">
          <div class="d-flex justify-content-center">
            <div *ngIf="act.isApprover">Approver</div>
            <div *ngIf="act.isRequestor">Requestor</div>
            <!-- <div class="activity-icon activity-{{act.isActive}}"></div> -->
          </div>
        </td>
        <!-- <td class="text-end">{{ act.order }}</td> -->
        <td class="text-center">
          <img
            class="cursor-pointer"
            title="Edit activity"
            (click)="editActivity(act.id)"
            src="design/images/edit.png"
          />
          <!-- <img class="cursor-pointer" title="Clone activity" *ngIf="act.activityType === 101"
                        (click)="cloneActivity(act)" src="design/images/copy.png" /> -->
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div class="card mt-3 text-center d-flex p-5" *ngIf="!activities.length">
  <div class="card-body">No activities found for the given filter values</div>
</div>
